/**
 * RAccordion's root is always a real element — `<details>` — so it can always
 * carry the column's className, and the component applies the one it receives.
 */
export const resolveRendersOwnElement = (): boolean => true;
